module.exports = __webpack_public_path__ + "img/phone6.48bac073.png";